import isNil from 'ramda/src/isNil';
import CheckBox from '@components/@core/CheckBox';
import ProgressBar from '@components/@core/ProgressBar';
import Input from '@components/@core/Input';
import { LibraryTypes } from '~/services/config';

const CareerCertificationHeader = ({ program, type, user, editable = false, changeTitle = () => {}, changeDescription = () => {} }) => {
    const { 
        title, 
        levels = program.data?.levels || program?.programLevels || [],
        stats = program.data?.stats || program?.stats || {},  
        description = program?.data?.description || program?.description
    } = program;
  
    return (
        <div className="d-flex ssm-column">
            <div className="career-certificate-title card ssm-100 w-40 w-sm-100 d-flex-5">
                <div className="header d-flex jc-between ai-center pt-2 pb-4">
                    <span className="dsl-b22 bold">{LibraryTypes[type].label}</span>
                </div>
                <div className="ai-center ps-1 mb-3">
                    <Input title={LibraryTypes[type].label} placeholder="Type here..." value={title} maxLength={30} onChange={changeTitle} disabled={!editable} />
                </div>
                {!editable && (
                    <div className="d-flex ai-center ps-1 mb-3">
                        <Input title="Assignee"  maxLength={80}  value={user?.name} disabled={true} />
                    </div>
                )}
                <div className="ai-start ps-1">
                    <Input title="Description" as="textarea" rows="3" maxLength={80} placeholder="Type here..." value={description} onChange={changeDescription} disabled={!editable} />
                </div>
            </div>
            <div className="career-map card  d-flex-5">
                <div className="header">
                    <span className="dsl-b22 bold">Levels</span>
                </div>
                <div className="levels-wrapper ps-1">
                    {Object.entries(levels).map(([key, level]) => {
                        const levelStats = stats?.levels ? stats.levels[key] : stats;
                        const courses = levelStats?.courses;
                        const quotas = levelStats?.quotas;
                        const totals = (isNil(quotas) ? 0 : quotas.total) + (isNil(courses) ? 0 : courses.total);
                        const complete = (isNil(quotas) ? 0 : quotas.complete) + (isNil(courses) ? 0 : courses.complete);
                        const totalProgress = totals === 0 ? 100 : ((complete * 100) / totals).toFixed(2);
                        const isCompleted = !isNil(level.completed_at) || (level?.started_at && totalProgress === 100);

                        return (
                            <div className="d-flex py-2 d-h-between" key={`lv-${key}`}>
                                <div className="d-flex">
                                    <CheckBox className="me-3" size="regular" checked={isCompleted} />
                                    <span className={`dsl-b16 ${isCompleted ? 'line-through' : ''} truncate-one`}>{level.title || level.levelTitle}</span>
                                </div>
                                <div className="d-flex progressbar-wrapper">
                                    {level.started_at ? <span className="dsl-b16 me-3">{`${complete}/${totals}`}</span> : null}
                                    {!level.started_at ? <span className="dsl-b16">Not started</span> : <ProgressBar className="level-progress" value={Number(totalProgress)} />}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default CareerCertificationHeader;
